export enum OrganizationRoles {
  Member = "member",
  Admin = "admin",
}
